export default __webpack_public_path__ + "static/media/fotovoltaticoSemplice_logo.918f8abb.png";